"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.evalNode = void 0;
const ast_1 = require("./ast");
const chrono_1 = require("./chrono");
const exception_1 = require("./exception");
const number_1 = require("./number");
const value_1 = require("./value");
const visitor = {
    visitDefinition(node) {
        throw new exception_1.SyntaxError(`Unable to evaluate defition of \`${node.id}' as expression.`, node.position);
    },
    visitLiteral(node) {
        return node.value;
    },
    visitRecordLiteral(node, context) {
        const elements = new Map();
        for (const [key, value] of node.elements) {
            elements.set(key, (0, exports.evalNode)(context, value));
        }
        return (0, value_1.newRecordValue)(elements);
    },
    visitSymbol(node, context) {
        const { id } = node;
        if (id === "true") {
            return (0, value_1.newBooleanValue)(true);
        }
        else if (id === "false") {
            return (0, value_1.newBooleanValue)(false);
        }
        else if (id === "drop") {
            return context.pop();
        }
        else if ((0, number_1.isValidNumber)(id)) {
            return (0, number_1.parseNumberValue)(id);
        }
        else if ((0, chrono_1.matchesDatePattern)(id)) {
            return (0, chrono_1.parseDateValue)(id);
        }
        else if ((0, chrono_1.matchesTimePattern)(id)) {
            return (0, chrono_1.parseTimeValue)(id);
        }
        else if ((0, chrono_1.isValidMonth)(id)) {
            return (0, chrono_1.parseMonthValue)(id);
        }
        else if ((0, chrono_1.isValidWeekday)(id)) {
            return (0, chrono_1.parseWeekdayValue)(id);
        }
        throw new exception_1.NameError(`Unable to evaluate \`${id}' as expression.`, node.position);
    },
    visitVectorLiteral(node, context) {
        return (0, value_1.newVectorValue)(node.elements.map((element) => (0, exports.evalNode)(context, element)));
    },
};
/**
 * Evaluates given AST node as expression.
 */
const evalNode = (context, node) => (0, ast_1.visitNode)(visitor, node, context);
exports.evalNode = evalNode;
